import 'ui-core/components/drop-block/js/drop-block';

const dropBlock = UX.dropBlock || {};

if (dropBlock) {
    dropBlock.additionalOnShow = function () {
        var input = $('#header-quick-search-form .ui-autocomplete-input');
        if (input.length) {
            input[0].setSelectionRange(-1, -1);
            input.focus();
        }
    };
}
